import React, { useReducer, useEffect, useRef, useState } from "react";
import { defaultState, initialize, CustodySimpleReducer, validateErr } from "./reducer";
import {
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Container,
  Row,
  Col,
  Input,
  Button,
  Spinner,
  UncontrolledDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  CustomInput,
  FormGroup,
  Alert,
} from "reactstrap";
import style from "./Custody.module.scss";
import { Field, Combobox } from "../Order/Field/Field";
import LaddaButton, { EXPAND_RIGHT } from "react-ladda";
import CustodianEntity from "../CustodianEntity/CustodianEntity";
import { Mode } from "../../Asset/types";
import { LoadingMessage } from "../Authorization/Processes";
import CurrencyList from "./CurrencyList/CurrencyList";
import AutosuggestFund from "../../Autosuggest/Autosuggest";
import CustodyRateTable from "./CustodyRateRange/CustodyRateTable";
import { Numeric } from "../Order/Field/Field";
import CustomAutosuggest from "./CustomAutosuggest";

const CustodySet = ({ open, custodyRateTable, id, toggle, fetchs, ...props }) => {
  const titleRef = useRef();
  const [state, dispatch] = useReducer(CustodySimpleReducer, defaultState(), initialize(props));
  const [fundManager, setFundManager] = useState(false);
  const [errorMsg, setErrorMsg] = useState(null);
  const [fund, setFund] = useState({ FundId: 0, FundName: "" });
  const {
    dialogMode,
    globalError,
    custody,
    buttons,
    initialized,
    errors,
    message,
    sentAuthorization,
    openCustodianEntity,
    isEditCustodianEntity,
    custodianEntity,
    custodianEntityId,
    custodianEntityName,
  } = state;

  const accountType = [
    { id: 1, description: "Customer", name: "Customer", prop: false },
    { id: 2, description: "In Balance", name: "InBalance", prop: true },
  ];
  const RechargeCustodianEntity = (id) => {
    props.callApi("GetCustodianEntity", {}).then((response) => {
      dispatch({ type: "RECHARGE_CUSTODIAN_ENTITY", response, id });
    });
  };

  useEffect(() => {
    props.services.isFundManagerSistem().then((r) => {
      if (
        r.response &&
        r.response.SdtParametersData &&
        parseInt(r.response.SdtParametersData.ParameterNumericValue) === 1
      )
        setFundManager(true);
    });
  }, []);

  useEffect(() => {
    if (open && !id) {
      dispatch({ type: "CHANGE_FIELDS", fields: { currencyAccounts: [] } });
      dispatch({ type: "CHANGE_FIELDS", fields: { rateRanges: [] } });
    }
  }, [open]);

  useEffect(() => {
    props.callApi("GetCustodianEntity", {}).then((response) => {
      dispatch({ type: "GET_CUSTODIAN_ENTITY", response });
    });
  }, []);

  useEffect(() => {
    if (id) {
      dispatch({ type: "CHANGE_DIALOG_MODE", nextMode: Mode.Update });
      props.callApi("GetCustodyAccount", { id }).then(({ custody, result }) => {
        if (result.Code === 200) {
          dispatch({ type: "LOAD_FOR_EDIT_CUSTODY", fields: custody });
          if (custody.CustodianRelatedAccountId > 0) {
            setFund({ FundId: custody.fundCode, FundName: custody.fundName });
          }
        } else {
          dispatch({ type: "LOAD_FOR_EDIT_CUSTODY", fields: custody });
          alert(result.Description);
        }
      });
    }
  }, [id]);

  useEffect(() => {
    if (!id) {
      if (custodianEntity && custodianEntity.length > 0) {
        if (props.currencies && props.currencies.length > 0) {
          if (props.imputableAccounts && props.imputableAccounts.length > 0) {
            dispatch({ type: "INITIALIZE_VALUES", ...props });
          }
        }
      }
    }
  }, [id, custodianEntity, props.currencies, props.imputableAccounts]);

  const renderSuggestion = (suggestion) => (
    <div>
      {suggestion.isin}
      {" - "}
      <span>{suggestion.name}</span>
    </div>
  );

  const getSuggestionValue = (suggestion) => `${suggestion.isin} - ${suggestion.name}`;

  const onSuggestionsFetchRequested = ({ value }) =>
    props.services.fetchGetFunds({ filter: { text: value, offset: 0, length: 20 } }).then((response) =>
      response.response.items.map((a) => {
        return {
          isin: a.AssetISIN,
          name: a.AssetName,
          id: a.AssetId,
        };
      })
    );

  const onChangeFund = (method, newValue) => {
    if (newValue && (method == "click" || method == "enter")) {
      setFund({
        FundId: newValue.id,
        FundName: newValue.name,
      });
      onChange({ CustodianRelatedAccountId: newValue.id });
    }
  };

  const confirm = () => {
    dispatch({ type: "VALIDATE_FIELDS", ...props });
    const error = validateErr(state, fundManager);
    if (error == "") {
      setErrorMsg(null);
      dispatch({
        type: "UPDATE_BUTTONS",
        buttons: { confirm: { loading: true } },
      });
      const action = dialogMode === Mode.Update ? "UPD" : "INS";
      var body = {
        action,
        custody: { ...custody, entityId: custodianEntityId },
      };
      props.onSetCustody("SetCustody", body).then((response) => {
        if (dialogMode === Mode.Update) {
          dispatch({
            type: "UPDATE_BUTTONS",
            buttons: { confirm: { loading: false } },
          });
          if (response.result.Code === 200) {
            props.onClickClose();
          } else {
            titleRef.current.scrollIntoView();
            titleRef.current.focus();
            dispatch({
              type: "UPDATE_FIELDS",
              fields: { globalError: response.result.Description },
            });
          }
        } else {
          dispatch({ type: "SENT_AUTHORIZATION", response });
        }
      });
    } else {
      setErrorMsg(error);
    }
  };

  const onChange = (fields) => dispatch({ type: "CHANGE_FIELDS", fields });

  const EditClearingHouse = () => {
    dispatch({ type: "EDIT_CLEARING_HOUSE", ...props });
  };
  const onChangeClearingHouse = (fields) => dispatch({ type: "CLEARING_HOUSES_FIELDS", fields });
  const CancelClearingHouse = () => {
    dispatch({ type: "CLOSE_CLEARING_HOUSE" });
  };
  const addClearingHouse = () => {
    dispatch({ type: "ADD_CLEARING_HOUSE", ...props });
  };
  const EditClearingHouseId = (c) => dispatch({ type: "EDIT_CLEARING_HOUSE_ID", c, ...props });
  const SaveEditClearingHouse = () => {
    dispatch({ type: "SAVE_EDIT_CLEARING_HOUSE", ...props });
  };
  const onChangeAccountType = (fields) => {
    dispatch({ type: "CHANGE_FIELDS_ACCOUNT_TYPE", fields });
  };
  const InitializeValues = () => {
    dispatch({ type: "INITIALIZE_VALUES", ...props });
  };
  const ResetClose = () => {
    dispatch({ type: "RESET_CLOSE", ...props });
  };
  const OpenCustodianEntity = () => {
    dispatch({ type: "OPEN_CUSTODIAN_ENTITY", ...props });
  };
  const CloseCustodianEntity = () => {
    dispatch({ type: "CLOSE_CUSTODIAN_ENTITY", ...props });
  };
  const EditCustodianEntity = () => {
    dispatch({ type: "EDIT_CUSTODIAN_ENTITY", ...props });
  };
  const UpdateFields = (fields) => {
    dispatch({ type: "UPDATE_FIELDS", fields });
  };

  const isEditing = dialogMode === Mode.Update;

  if (!open) {
    return null;
  }

  return (
    <div>
      <Modal isOpen={open} className={style.modal}>
        <ModalHeader toggle={() => ResetClose()}>
          <div ref={titleRef}>{isEditing ? "Edit custody account" : "New custody account"}</div>
        </ModalHeader>
        <ModalBody className={style.body}>
          {dialogMode === Mode.Update && initialized === false ? (
            <div className="mt-5 mb-5">
              <LoadingMessage text="Loading custody info" />
            </div>
          ) : (
            <Container>
              {!!globalError && (
                <Alert className="pt-2 pb-2" color="danger">
                  {globalError}
                </Alert>
              )}
              {isEditing && custody.currencyAccounts.length == 0 && (
                <Alert className="pt-2 pb-2" color="warning">
                  Imputable accounts is empty
                </Alert>
              )}
              <Row>
                <Col lg={4} xs={12}>
                  <Field label={"Account Name"} error={errors.name}>
                    <Input
                      type={"text"}
                      placeholder={"Account Name"}
                      value={custody.name || ""}
                      invalid={errors.name}
                      onChange={(e) => onChange({ name: e.target.value })}
                    />
                  </Field>
                </Col>
                <Col lg={4} xs={12}>
                  <Field label={"Account Type"} error={errors.accountType}>
                    <Combobox
                      style={{ background: "#edf9ff", fontWeight: 500 }}
                      value={custody.accountType}
                      disabled={isEditing}
                      onChange={(v) => onChangeAccountType({ accountType: v })}
                      items={Object.values(accountType).map((key, index) => ({
                        id: key.id,
                        description: key.description,
                      }))}
                    />
                  </Field>
                </Col>
                <Col lg={3} xs={12} style={{ paddingRight: "0px" }}>
                  <Field label={"Custodian Entity"} error={errors.custodianEntityId}>
                    <LoadingWrapper loading={props.loadingCustodianEntity}>
                      <CustomAutosuggest
                        custodianEntity={custodianEntity}
                        custodianEntityId={custodianEntityId}
                        custodianEntityName={custodianEntityName}
                        isEditing={isEditing}
                        errors={errors.custodianEntityId}
                        UpdateFields={UpdateFields}
                      />
                    </LoadingWrapper>
                  </Field>
                </Col>
                <Col lg={1} xs={12} style={{ paddingLeft: "0px", display: "flex" }}>
                  <UncontrolledDropdown disabled={isEditing} style={{ bottom: "0px", display: "contents" }}>
                    <DropdownToggle
                      style={{ top: "5px", position: "relative" }}
                      direction="down"
                      color="link"
                    >
                      <i class="fa fa-ellipsis-v fa-lg" aria-hidden="true"></i>
                    </DropdownToggle>

                    <DropdownMenu style={{ marginBottom: "5px" }}>
                      <DropdownItem onClick={() => OpenCustodianEntity()}>New</DropdownItem>
                      <DropdownItem onClick={() => EditCustodianEntity()}>Edit</DropdownItem>
                    </DropdownMenu>
                  </UncontrolledDropdown>
                </Col>
              </Row>
              {custodyRateTable ? (
                <Row>
                  <Col lg={12}>
                    <CustodyRateTable
                      items={custody.rateRanges || []}
                      loadings={{
                        imputableAccounts: props.loadingImputableAccounts,
                        currencies: props.loadingCurrencies,
                      }}
                      imputableAccounts={props.imputableAccounts}
                      currencies={props.currencies}
                      onChange={onChange}
                      custody={custody}
                      errors={errors}
                    ></CustodyRateTable>
                  </Col>
                </Row>
              ) : (
                <Row>
                  <Col lg={4} xs={12}>
                    <Field label={"Money Market Rate"} error={errors.CustodianMoneyMarketRate}>
                      <Numeric
                        dataTypeDecimalName="quantity"
                        placeholder={"Money Market Rate"}
                        value={custody.CustodianMoneyMarketRate || ""}
                        invalid={errors.CustodianMoneyMarketRate}
                        onChange={(e) => onChange({ CustodianMoneyMarketRate: e })}
                      />
                    </Field>
                  </Col>
                  <Col lg={4} xs={12}>
                    <Field label={"Margin Rate"} error={errors.CustodianMarginRate}>
                      <Numeric
                        dataTypeDecimalName="quantity"
                        placeholder={"Margin Rate"}
                        value={custody.CustodianMarginRate || ""}
                        invalid={errors.CustodianMarginRate}
                        onChange={(e) => onChange({ CustodianMarginRate: e })}
                      />
                    </Field>
                  </Col>
                  <Col lg={4} xs={12}>
                    <Field label={"Money Market Rate Min"} error={errors.CustodianMoneyMarketRateMin}>
                      <Numeric
                        dataTypeDecimalName="quantity"
                        placeholder={"Money Market Rate Min"}
                        value={custody.CustodianMoneyMarketRateMin || ""}
                        invalid={errors.CustodianMoneyMarketRateMin}
                        onChange={(e) => onChange({ CustodianMoneyMarketRateMin: e })}
                      />
                    </Field>
                  </Col>
                </Row>
              )}

              {fundManager && (
                <Row>
                  <Col lg={4} xs={12}>
                    <Field label={"Fund"} error={errors.CustodianRelatedAccountId}>
                      <AutosuggestFund
                        inputProps={{
                          placeholder: "Fund",
                          invalid: errors.CustodianRelatedAccountId,
                          disabled: isEditing,
                        }}
                        renderSuggestion={renderSuggestion}
                        getSuggestionValue={getSuggestionValue}
                        onSuggestionsFetchRequested={onSuggestionsFetchRequested}
                        onSuggestionSelected={onChangeFund}
                        value={
                          custody.CustodianRelatedAccountId != 0 ? `${fund.FundId} - ${fund.FundName}` : ""
                        }
                        onChange={onChangeFund}
                      />
                    </Field>
                  </Col>
                </Row>
              )}
              <Row>
                <Col lg={12}>
                  <CurrencyList
                    items={custody.currencyAccounts}
                    loadings={{
                      imputableAccounts: props.loadingImputableAccounts,
                      currencies: props.loadingCurrencies,
                    }}
                    imputableAccounts={props.imputableAccounts}
                    currencies={props.currencies}
                    onChange={onChange}
                  />
                </Col>
              </Row>
              <Row>
                <Col lg={4} xs={12}>
                  <FormGroup>
                    <CustomInput
                      label="Is custody cash?"
                      id="cboxCustodiesCash"
                      type="checkbox"
                      checked={custody.custodiesCash}
                      onChange={(e) => onChange({ custodiesCash: !custody.custodiesCash })}
                    />
                  </FormGroup>
                </Col>
                <Col lg={4} xs={12}>
                  <FormGroup>
                    <CustomInput
                      label="Is custody value?"
                      id="cboxCustodiesValues"
                      type="checkbox"
                      checked={custody.custodiesValues}
                      onChange={(e) => onChange({ custodiesValues: !custody.custodiesValues })}
                    />
                  </FormGroup>
                </Col>
                <Col lg={4} xs={12}>
                  <FormGroup>
                    <CustomInput
                      label="Is local bank?"
                      id="cboxLocalBank"
                      type="checkbox"
                      checked={custody.isLocalBank}
                      onChange={(e) => onChange({ isLocalBank: !custody.isLocalBank })}
                    />
                  </FormGroup>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field label={"Fee Schema"} error={errors.feeSchema}>
                    <Input
                      type={"textarea"}
                      placeholder={"Fee Schema"}
                      value={custody.feeSchema || ""}
                      invalid={errors.feeSchema}
                      onChange={(e) => onChange({ feeSchema: e.target.value })}
                    />
                  </Field>
                </Col>
              </Row>
              <Row>
                <Col>
                  <Field label={"Description"} error={errors.description}>
                    <Input
                      type={"textarea"}
                      placeholder={"Description"}
                      value={custody.description || ""}
                      invalid={errors.description}
                      onChange={(e) => onChange({ description: e.target.value })}
                    />
                  </Field>
                </Col>
              </Row>
            </Container>
          )}
        </ModalBody>
        <ModalFooter>
          {errorMsg && (
            <Alert color="danger" className="p-2 pl-3 mb-0 pr-3 mr-3">
              {errorMsg}
            </Alert>
          )}
          {sentAuthorization ? (
            <div className="d-inline-flex">
              <Alert color="success" className="p-2 pl-3 mb-0 pr-3 mr-3">
                {message}
              </Alert>
              <Button color="light" onClick={() => ResetClose()}>
                Close
              </Button>
            </div>
          ) : (
            <div>
              <Button color="light" onClick={() => ResetClose()}>
                Close
              </Button>

              <LaddaButton
                className="btn btn-ladda btn-primary ml-2"
                loading={buttons.confirm.loading}
                onClick={() => confirm()}
                data-style={EXPAND_RIGHT}
              >
                Confirm
              </LaddaButton>
            </div>
          )}
        </ModalFooter>
      </Modal>
      {openCustodianEntity ? (
        <CustodianEntity
          open={true}
          callApi={props.callApi}
          CloseCustodianEntity={CloseCustodianEntity}
          isEditCustodianEntity={isEditCustodianEntity}
          entityId={custodianEntityId}
          RechargeCustodianEntity={RechargeCustodianEntity}
        />
      ) : (
        <div></div>
      )}
    </div>
  );
};

const LoadingWrapper = ({ children, loading }) =>
  loading ? <Spinner size="sm" className="d-block" style={{ margin: "0px 50%" }} /> : children;

const EmptyClearingHouses = () => (
  <tr className={style.empty}>
    <td colSpan="4">
      <h5 style={{ textAlign: "center" }}>No Clearing Houses</h5>
    </td>
  </tr>
);

export default CustodySet;
